import React from 'react';
import { GlobalErrorComponent } from '@trp-rps-rps-shared-web/rps-shared-web-components';

class ErrorBoundary extends React.Component<any, { hasError: boolean }> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // You can also log the error to an error reporting service
    //logErrorToMyService(error, errorInfo);
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <>
          <GlobalErrorComponent
            message={`Sorry! We’re having technical problems. Please try again.`}
            refreshText={`Refresh`}
            dismissError={false}
          />
        </>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
